<template class="template-page" >

    <spinner v-if="!loaded" ></spinner>

    <div v-else-if="loaded" class="pt-2 pl-2 pr-2 pb-2 pl-md-4 pr-md-4" >
        
        <overview v-if="APPKEY != null" :passedAPPKEY="APPKEY" ></overview>
        
        <div class="row no-gutters mb-3 mt-5" >
            
            <div class="col-12" >
                <span class="h2 font-900" style="line-height: 34px; margin-rigth: 15px" > Last 12 months  </span>
            </div>
            
        </div>
        
        <acquisition v-if="APPKEY != null" :passedAPPKEY="APPKEY" contentType="stats" ></acquisition>
        
    </div>

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'
    
import overview from '@/templates/analyze/Overview-v2.vue'     
import acquisition from '@/templates/analyze/Acquisition.vue'     
    
export default {
    name: "GuestStats",
    components:{
        overview,
        acquisition
    },
    data () {
        return {
            loaded: false,
            APPKEY: null
        }
    },
    beforeCreate: function (){
        
    },
    created: function () {
        
       //window.location.href = '/login'
       //this.$router.push('/login')
        //this.loaded = true
        
        let urlParams = new URLSearchParams(window.location.search);
        if( urlParams.has('code') ){
            let code = urlParams.get('code')
            this.codeCheck( code )
        }else{
            this.$router.push('/login')
        }

    },
    methods: {
        codeCheck( code ){
                        
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
                        
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/analyze/code-check', 
                headers: headers, 
                data: { 
                    "code": code
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.data.body.status === true ){
                    this.loaded = true
                    this.APPKEY = resp.data.body.app
                }else{
                    this.$router.push('/login')
                }
            })
            .catch(error => {
                
                console.log(error)
                this.$router.push('/login')
                
            }); //end axios 
            
        }
    },
    computed: {
        
    },
}
</script>

<style >
    html, body{
        background: #eaeaea!important;
    }
    .guest-stats #tidio-chat-iframe,
    .guest-stats #tidio-chat
    {
        display: none!important;
    }
    .guest-stats .left-nav{
        display: none;
    }
    .guest-stats .mainLogged{
        width:100%;
        left:0;
    }
</style>


// WEBPACK FOOTER //
// src/templates/analyze/guestOverview.vue